<div *ngIf="shouldShowErrors()">
  {{ listOfErrors() }}
</div>
